import { useQueryClient } from "@tanstack/react-query"

import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { roadsideQueryKeys } from "../queries/queryKeys"

import { useRoadsideInventoriesMutation } from "./useRoadsideInventoriesMutation"


export function useRoadsideInventoriesBatchUpdate(
    queryParameters,
    config: any = {},
) {
    const { selectedNetwork } = useNetworksStateContext()
    const url = "batch_update/"

    const queryClient = useQueryClient()

    return useRoadsideInventoriesMutation(
        url,
        axiosInstance.post,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                const projectParam = {
                    project: selectedNetwork?.slug,
                }
                queryClient.invalidateQueries({ queryKey: roadsideQueryKeys["list"](projectParam) })
                queryClient.invalidateQueries({ queryKey: roadsideQueryKeys["homogenousZones"](projectParam) })
                queryClient.invalidateQueries({ queryKey: roadsideQueryKeys["conditionsStats"](projectParam) })
                queryClient.invalidateQueries({ queryKey: roadsideQueryKeys["stats_inventory_types"](projectParam) })
                config.onSuccess?.(data)
            },
        },
    )
}